import script from "./OrganizationConnections.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationConnections.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationConnections.vue?vue&type=style&index=0&id=28f76d96&lang=scss"

const __exports__ = script;

export default __exports__